// Tiny localStorage helpers — SSR-safe and exception-safe.

const isAvailable = () => {
  try {
    return (
      typeof window !== "undefined" &&
      typeof window.localStorage !== "undefined"
    );
  } catch {
    return false;
  }
};

export const loadLS = (key, fallback = undefined) => {
  if (!isAvailable()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const saveLS = (key, value) => {
  if (!isAvailable()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // quota / serialize error — ignore
  }
};

export const removeLS = (key) => {
  if (!isAvailable()) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

// Veri Girişi keys (per-kind storage)
export const VERI_KEYS = {
  avans: "syp.veri_girisi.avans",
  mesai: "syp.veri_girisi.mesai",
  kasaAcik: "syp.veri_girisi.kasaAcik",
  kesinti: "syp.veri_girisi.kesinti",
  periods: "syp.veri_girisi.periods",
};

// Z-Rapor module
export const ZRAPOR_KEYS = {
  definitions: "syp.zrapor.definitions",
  reports: "syp.zrapor.reports",
  dailyClosure: "syp.zrapor.daily_closure",
  dailyExtras: "syp.zrapor.daily_extras",
};
